<template>
    <div :class="['list-item', classes]">
        <component :is="getComponentType" v-bind="getComponentProps">
            <img v-if="item.image" :src="item.image" :alt="item.image" />
            <span v-if="item.label">{{ item.label }}</span>
        </component>
    </div>
</template>

<script>
import parseFooterItemHandler from '@/themes/novaporta/mixins/parse-footer-item-handler';
export default {
    name: 'LinksItem',
    mixins: [parseFooterItemHandler],
    computed: {
        getComponentType() {
            const componentTypes = {
                link: 'NuxtLink',
                tagLink: 'a',
                image: 'img'
            };

            return componentTypes[this.type] || 'div';
        },
        getComponentProps() {
            const componentProps = {
                link: { to: this.localePath({ path: `/${this.item.link ? this.item.link?.replace(/^\/+/, '') : ''}` }) },
                tagLink: { href: this.item.link, target: '_blank', rel: 'noopener noreferrer' },
                image: { src: this.item.image, alt: this.item.image }
            };

            return componentProps[this.type] || {};
        }
    }
};
</script>

<style lang="scss" scoped>
@import '../../../context.scss';
</style>
